export default {"src":"/_next/static/media/company-crafted-pathways.d8ce8eca.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};